import Navbar from "../../../atoms/navbar";
import { Button, Flex, Select, Option, Input } from "antd";
import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import API from "../../../services";
import { loginRequest } from "../../../config/api.config";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import HeaderFarms from "../../../utils/header_farms";
import { _ } from "numeral";
import { get } from "react-hook-form";



export default function SapBiddingHistoryPage() {
    let navigate = useNavigate();
    const [biddingHdr, setBiddingHdr] = useState([]);
    const [biddingHdrFilter, setBiddingHdrFilter] = useState([]);
    const [statusFilter, setStatusFilter] = useState("Waiting Approval");
    const [userBranch, setUserBranch] = useState([]);
    const [seachList, setSearchList] = useState("");
    const { instance, accounts } = useMsal();
    const [currentSession, setCurrentSession] = useState(
        JSON.parse(localStorage.getItem("session_signin"))
    );
    const isAuthenticated = useIsAuthenticated();

    const loadBiddingHdr = async () => {
        const request = {
            ...loginRequest,
            account: accounts[0],
        };
        const responseToken = await instance.acquireTokenSilent(request).catch(e => {
            console.error("Token acquisition failed", e);
            throw e;
        });
        const accessToken = responseToken.accessToken;

        const headers = HeaderFarms(accessToken);
        const reponse = await API.sapGetListBiddingByBuyerID(headers, currentSession.nik);
        if (reponse.code === 200) {
            const data = await reponse.data;
            const filteredData = data.filter(
                item =>
                    item.approval_header?.status === statusFilter
            );
            setBiddingHdr(data);
            setBiddingHdrFilter(filteredData);
            console.log(filteredData)
        } else {
            console.error("Error fetching bidding history:", reponse.statusText);
        }

    }
    function RequestToken() {
        const request = {
            ...loginRequest,
            account: accounts[0],
        };

        instance
            .acquireTokenSilent(request)
            .then((response) => {
                if (!currentSession) {
                    getUser(response.accessToken);
                }

            })
            .catch((e) => {
                handleLogin(instance);
                console.error(e);
            });
    }

    function handleLogin(instance) {
        instance
            .loginRedirect(loginRequest)
            .then(() => { })
            .catch((e) => {
                console.error(e);
            });
    }

    async function getUser(token) {
        try {
            let user = await API.getUserCredential(HeaderFarms(token), {
                access_token: token,
            });
            setCurrentSession(user);
        } catch (error) {
            console.error(error);
        }
    }


    function handleChangeFilter(value) {
        setStatusFilter(value);

        const filteredData = biddingHdr.filter(item =>
            (
                (item.buyer_name?.toLowerCase() || "").includes(seachList) ||
                (item.record_id?.toString() || "").includes(seachList)
            ) &&
            item.approval_header?.status == value
        );

        setBiddingHdrFilter(filteredData);
    }

    const handleSearch = (e) => {
        const searchValue = e.target.value.toLowerCase();
        setSearchList(searchValue);
        const filteredData = biddingHdr.filter(item =>
            (item.buyer_name.toLowerCase().includes(searchValue) ||
                item.pr_num.toLowerCase().includes(searchValue) ||
                item.vendor_selected.toLowerCase().includes(searchValue) ||
                item.id_record.toString().includes(searchValue)) && item.tapproval_hdr[0]?.status == statusFilter
        );
        setBiddingHdrFilter(filteredData);
    }

    useEffect(() => {
        loadBiddingHdr();
        if (!isAuthenticated) {
            RequestToken();
        } else {
            if (instance.getAllAccounts().length > 0) {
                instance.setActiveAccount(accounts[0]);
                RequestToken();

            } else {
                handleLogin(instance);
            }
        }
    }, []);

    return (
        <Fragment>
            <Navbar title="History"
                back={true}
                subtitle="Bidding"
                navigate="/">

            </Navbar>
            <div className="container white-back-cr" style={{ minHeight: 500 }}>
                <div className="conteiner-mt3 p-3">
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="col-md-6d-flex justify-content-start">
                                <Button type="primary" size="middle"
                                    onClick={() => navigate("/sapbdng/create")}
                                >
                                    Create New
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3 mb-3">
                        <div className="col">
                            <Input.Search
                                placeholder="Search bidding..."
                                allowClear
                                style={{ width: '100%' }}
                                onChange={(e) => { handleSearch(e) }}
                                value={seachList}
                            />
                        </div>
                        <div className="col-md-6 d-flex justify-content-end">
                            <label style={{ marginRight: 10, marginTop: 5 }}>Filter</label>
                            <Select
                                defaultValue="Waiting"
                                onChange={handleChangeFilter}
                                style={{
                                    width: 120,
                                }}
                            >
                                <Select.Option value="Waiting Approval">Pending</Select.Option>
                                <Select.Option value="Approved">Approved</Select.Option>
                                <Select.Option value="Reject">Rejected</Select.Option>
                            </Select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 col-sm-12 mt-3">
                            <table className="table table-bordered table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th>Bid No</th>
                                        <th>Buyer</th>
                                        <th>Req Num</th>
                                        <th>Date</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                        <th>pending</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {biddingHdrFilter.map((item, index) => {
                                        if (item.buyer_id !== String(currentSession.nik)) {
                                            return null;

                                        }

                                        return (
                                            <tr key={index}>
                                                <td>{item.record_id}</td>
                                                <td>{item.buyer_name}</td>
                                                <td>{item.rfq_num}</td>
                                                <td>{item.created_at}</td>
                                                <td>
                                                    {item.approval_header?.status === "Waiting Approval" ? (
                                                        <Button variant="outlined" style={{ borderColor: "orange", color: "orange" }}>
                                                            Pending
                                                        </Button>
                                                    ) : item.approval_header?.status === "Approved" ? (
                                                        <Button variant="outlined" style={{ borderColor: "green", color: "green" }}>
                                                            Approved
                                                        </Button>
                                                    ) : item.approval_header?.status === "Reject" ? (
                                                        <Button variant="outlined" style={{ borderColor: "red", color: "red" }}>
                                                            Rejected
                                                        </Button>
                                                    ) : null}
                                                </td>
                                                <td>
                                                    <Button
                                                        type="primary"
                                                        onClick={() => window.open(`/wf/sapbdng/view/${item.record_id}`, "_blank")}
                                                        size="middle"
                                                    >
                                                        View
                                                    </Button>
                                                </td>
                                                <td>
                                                    {item.approval_detail
                                                        .filter(dtl => dtl.status === false && dtl.rejected === false)
                                                        .map((dtl, i) => (
                                                            <div key={i}>{dtl.approver_id}</div>
                                                        ))}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
